module.exports = __webpack_public_path__ + "img/nologo.9c828faa.png";